export interface ISuicleanContract {
    id_customer_contrat: number | null
    date: string | null
    date_end: string | null
    duration_months: number | null
    duration_years: number | null
    volume_l: number | null
    total_bidons: number | null
}

export interface ISuicleanProduct {
    key: string
    label: string
    color: string | null
    dilution_percent: number
    bidons_consumed: number
    concentrate_l: number
    solution_l: number
    water_l: number
}

export interface ISuicleanTotals {
    bidons_consumed: number
    bidons_remaining: number | null
    bidons_total: number | null
    consumed_percent: number | null
    remaining_percent: number | null
    concentrate_l: number
    solution_l: number
    water_l: number
}

export interface ISuicleanTransport {
    weight_kg: number
    distance_km: number
    co2_kg: number
    bidon_weight_kg: number
    co2_per_bidon_kg: number
    factor_kg_per_tonne_km: number
    avoided_weight_kg: number
    avoided_co2_kg: number
    avoided_bidons: number
}

export interface ISuicleanDashboard {
    has_suiclean: boolean
    client_code: string | null
    contract: ISuicleanContract
    range: {
        date_begin: string
        date_end: string
    }
    products: Array<ISuicleanProduct>
    totals: ISuicleanTotals
    transport: ISuicleanTransport
}

export const EmptySuicleanDashboard: ISuicleanDashboard = {
    has_suiclean: false,
    client_code: null,
    contract: {
        id_customer_contrat: null,
        date: null,
        date_end: null,
        duration_months: null,
        duration_years: null,
        volume_l: null,
        total_bidons: null,
    },
    range: {
        date_begin: '',
        date_end: '',
    },
    products: [],
    totals: {
        bidons_consumed: 0,
        bidons_remaining: null,
        bidons_total: null,
        consumed_percent: null,
        remaining_percent: null,
        concentrate_l: 0,
        solution_l: 0,
        water_l: 0,
    },
    transport: {
        weight_kg: 0,
        distance_km: 0,
        co2_kg: 0,
        bidon_weight_kg: 5,
        co2_per_bidon_kg: 0,
        factor_kg_per_tonne_km: 0.12,
        avoided_weight_kg: 0,
        avoided_co2_kg: 0,
        avoided_bidons: 0,
    },
}
